import ResizableScene from "../core/ResizableScene";

export class Confetti {
	static create(scene: ResizableScene, container: Phaser.GameObjects.Container): Phaser.GameObjects.Particles.ParticleEmitter[] {
		const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];
        const colors = [0xe2c000, 0xd92b2b, 0x2691e2];
		for (const img of ["confetti1", "confetti2", "confetti3", "confetti4", "confetti5"]) {
			const particles = scene.add.particles(img);
			container.add(particles);

			const emitter = particles.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1.1 },
				frequency: 300,
				lifespan: 2500,
				speedX: { min: -50, max: 300 },
				speedY: { min: 150, max: 400 },
			});
			emitters.push(emitter);

            const offsetX = Phaser.Math.RND.realInRange(-scene.viewport.width/2, scene.viewport.width/2);
			emitter.setPosition(offsetX, -scene.viewport.height/2);

			emitter.tint.onEmit = (p): number => {
				(<any>p).rotVel = Phaser.Math.RND.realInRange(-8, 8);
                p.tint = colors[Phaser.Math.RND.between(0, 2)];
				return p.tint;
			};

			emitter.tint.onUpdate = (p, _k, t, _value): number => {
				p.rotation = t * (<any>p).rotVel;
				return p.tint;
			};

			emitter.start();

			scene.events.on(Phaser.Scenes.Events.UPDATE, (): void => {
				const offsetX = Phaser.Math.RND.realInRange(-scene.viewport.width/2, scene.viewport.width/2);
				emitter.setPosition(offsetX, -scene.viewport.height/2);
			});
		}
		return emitters;
	}

	// Implement bursts for launch moment
	static createBurst(scene: ResizableScene, container: Phaser.GameObjects.Container): Phaser.GameObjects.Particles.ParticleEmitter[] {
		const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];
        const colors = [0xe2c000, 0xd92b2b, 0x2691e2];
		for (let i = 0; i < 10; i++) {
			for (const img of ["confetti1", "confetti2", "confetti3", "confetti4", "confetti5"]) {
				const particles = scene.add.particles(img);
				container.add(particles);
	
				const emitter = particles.createEmitter({
					alpha: { start: 1, end: 0.0 },
					scale: { min: 0.7, max: 1.1 },
					frequency: 100,
					lifespan: 2500,
					speedX: { min: 600, max: 800 },
					speedY: { min: -300, max: -250 },
				});
				emitters.push(emitter);
				const offsetX = Phaser.Math.RND.realInRange(-500, 0);
				const offsetY = Phaser.Math.RND.realInRange(-scene.viewport.height/2, -200);
				emitter.setPosition(-scene.viewport.width/2 + offsetX, offsetY);
	
				emitter.tint.onEmit = (p): number => {
					(<any>p).rotVel = Phaser.Math.RND.realInRange(-8, 8);
					p.tint = colors[Phaser.Math.RND.between(0, 2)];
					return p.tint;
				};
	
				emitter.tint.onUpdate = (p, _k, t, _value): number => {
					p.rotation = t * (<any>p).rotVel;
					p.accelerationY += 3;
					p.accelerationX -= 2;
					return p.tint;
				};
	
				emitter.start();
			}
	
			for (const img of ["confetti1", "confetti2", "confetti3", "confetti4", "confetti5"]) {
				const particles = scene.add.particles(img);
				container.add(particles);
	
				const emitter = particles.createEmitter({
					alpha: { start: 1, end: 0.0 },
					scale: { min: 0.7, max: 1.1 },
					frequency: 100,
					lifespan: 2500,
					speedX: { min: -800, max: -600 },
					speedY: { min: -500, max: -250 },
				});
				emitters.push(emitter);
				const offsetX = Phaser.Math.RND.realInRange(0, 500);
				const offsetY = Phaser.Math.RND.realInRange(-scene.viewport.height/2, -200);
				emitter.setPosition(scene.viewport.width/2 + offsetX, offsetY);
	
				emitter.tint.onEmit = (p): number => {
					(<any>p).rotVel = Phaser.Math.RND.realInRange(-8, 8);
					p.tint = colors[Phaser.Math.RND.between(0, 2)];
					return p.tint;
				};
	
				emitter.tint.onUpdate = (p, _k, t, _value): number => {
					p.rotation = t * (<any>p).rotVel;
					p.accelerationY += 3;
					p.accelerationX += 2;
					return p.tint;
				};
	
				emitter.start();
			}
		}
		
		return emitters;
	}

	static pauseEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.stop();
		}
	}

	static resumeEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.resume();
		}
	}
}